require('./_wks-define')('asyncIterator');


//////////////////
// WEBPACK FOOTER
// ./~/@deskproapps/dpat/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 9rNO
// module chunks = 0